import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { SUPPORTED_LANGS } from "@/i18n";

const DEFAULT_OG_IMAGE = `${window.location.origin}/assets/mockup-sos.webp`;

export const SEO = ({ title, description, image, schema, path = "" }) => {
  const { lang = "fr" } = useParams();
  const origin = window.location.origin;
  const canonical = `${origin}/${lang}${path ? `/${path}` : ""}`;
  const ogImage = image || DEFAULT_OG_IMAGE;

  useEffect(() => {
    document.querySelectorAll('[data-default="true"]').forEach((el) => el.remove());
    const staticTitle = document.getElementById("default-title");
    if (staticTitle) staticTitle.remove();
  }, []);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {SUPPORTED_LANGS.map((lg) => (
        <link
          key={lg}
          rel="alternate"
          hrefLang={lg}
          href={`${origin}/${lg}${path ? `/${path}` : ""}`}
        />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${origin}/fr${path ? `/${path}` : ""}`} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {schema && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />}
    </>
  );
};
